import { Checkbox as iCheckbox } from 'iview'
const map = (data, { groupName, groupBy, fieldCode, fieldText, fieldKey }) => {
  let m = {}
  data.forEach((i) => {
    let type = i[groupBy]
    if (!m[type]) {
      m[type] = { name: i[groupName], children: [] }
    }

    m[type].children.push({ ...i, _key: i[fieldKey], _code: i[fieldCode], _text: i[fieldText] })
  })
  return Object.values(m)
}

export default {
  name: 'Checkbox',
  data() {
    return {
      items: [],
      checked:[]
    }
  },
  props: {
    groupName: {
      default: 'groupName'
    },
    groupBy: {
      default: 'groupType'
    },
    fieldKey: {
      default: 'id'
    },
    fieldCode: {
      default: 'key'
    },
    fieldText: {
      default: 'value'
    },
    checkedKeys: {
      default:function(){
        return []
      }
    },
    data: {
      default: function() {
        return []
      }
    }
  },
  watch: {
   
    value(val) {
      console.log(val)
    },
    checkedKeys(val){
      console.log(val)
    }
  },
  created() {
    console.log('set Data', this.data.length)
    if (this.data && this.data.length) {
      this.setData(this.data)
    }
    this.checked = this.checkedKeys
  },
  methods: {
    setData(d) {
      this.items = map(d, this)
      this.map = this.$utils.map(d , this.fieldKey)
      console.log('>>>',this.items)
    },
    update() {

    },
    onChange() {
      // this.$emit('on-update', v)
      this.$emit('change', this.checked.map(i=>this.map[i]))

      // handleChange(v)
    }
  },
  render(){
    return <div class="slcheckbox">
    <CheckboxGroup v-model={this.checked} on-on-change={this.onChange}>
      <sl-detail-list col={1} label-width="100px" label-align="right" style="padding:12px;">
        {
          this.items.map((item) => <sl-detail-list-item title={item.name}>
            {
              item.children.map(child => <iCheckbox label={child._key} disabled={this.checkedKeys.includes(child._key)}>{child._text}</iCheckbox>)
            }
          </sl-detail-list-item>)
        }
      </sl-detail-list>
    </CheckboxGroup>
  </div>
  }
}

